// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.letter-box[data-v-310235d1] {\r\n  width: 30px;\r\n  height: 30px;\r\n  line-height: 30px;\r\n  display: inline-block;\r\n  text-align: center;\r\n  font-weight: bold;\r\n  border: 1px solid;\n}\r\n", ""]);
// Exports
module.exports = exports;
